var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderKey },
    [
      _vm.field.type !== "group" &&
      _vm.field.type !== "file" &&
      !_vm.field.render_params.hide
        ? _c(
            "formulate-input",
            _vm._b(
              {
                key: _vm.field.type,
                ref: "input",
                class: { disabled: _vm.disabled },
                attrs: { disabled: _vm.disabled },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "label",
                      fn: function(ref) {
                        var label = ref.label
                        return [
                          _c("label", [
                            _c("div", {
                              directives: [
                                {
                                  name: "html-safe",
                                  rawName: "v-html-safe",
                                  value: label,
                                  expression: "label"
                                }
                              ]
                            })
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1087330903
                )
              },
              "formulate-input",
              [
                _vm.field,
                _vm.extraBinds,
                _vm.$props,
                _vm.field.render_params || {}
              ],
              false
            )
          )
        : _vm.field.type !== "group" &&
          _vm.field.type === "file" &&
          !_vm.field.off &&
          !_vm.field.render_params.hide
        ? _c(
            "formulate-input",
            _vm._b(
              {
                key: _vm.field.type,
                ref: "input",
                class: { disabled: _vm.disabled },
                attrs: {
                  disabled: _vm.disabled,
                  value: _vm.field.render_params.value
                },
                scopedSlots: _vm._u(
                  [
                    _vm.field.type === "file"
                      ? {
                          key: "prefix",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "file-placeholder",
                                  staticStyle: {
                                    "text-shadow": "1px 1px 3px grey"
                                  }
                                },
                                [_vm._v(" Anexar documento ")]
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null,
                    {
                      key: "label",
                      fn: function(ref) {
                        var label = ref.label
                        return [
                          _c("label", [
                            _c("div", {
                              directives: [
                                {
                                  name: "html-safe",
                                  rawName: "v-html-safe",
                                  value: label,
                                  expression: "label"
                                }
                              ]
                            })
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              },
              "formulate-input",
              [
                _vm.field,
                _vm.extraBinds,
                _vm.$props,
                _vm.field.render_params || {}
              ],
              false
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }